module.exports = __webpack_public_path__ + "static/bantu-og-b375bcf6ea7abc3ca0ba948fe987779d.jpg";